import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Button, Empty } from 'antd';
import PropTypes from 'prop-types';

import OnTraccrCheckbox from '../inputs/OnTraccrCheckbox';

import { safeExtractFromObject } from '../../helpers/helpers';

export default function TableFilterDropdown({
  clearFilters,
  confirm,
  filters,
  selectedKeys,
  setSelectedKeys,
  visible,
}) {
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));

  const hasRedesign = settings?.uxRedesignPt1;

  const selectedKeySet = useMemo(() => new Set(selectedKeys), [selectedKeys]);
  const onCheckboxChange = (value) => (checked) => {
    const newSelectedKeys = new Set(selectedKeySet);
    if (checked) {
      newSelectedKeys.add(value);
    } else {
      newSelectedKeys.delete(value);
    }
    setSelectedKeys([...newSelectedKeys]);
  };

  const classSuffix = hasRedesign ? 'button-redesign-primary' : '';

  if (!visible) return null;

  return (
    <div className="ant-table-filter-dropdown" style={{ padding: '4px 0' }}>
      <div className="ant-dropdown-menu">
        {filters?.map((filter) => (
          <OnTraccrCheckbox
            style={{ padding: '5px 12px' }}
            label={filter.text}
            value={selectedKeySet.has(filter.value)}
            onChange={onCheckboxChange(filter.value)}
            key={filter.value}
          />
        ))}
        {!filters?.length && (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No filters" />
        )}
      </div>
      <div className="ant-table-filter-dropdown-btns">
        <Button
          className="ant-btn ant-btn-link ant-btn-sm"
          onClick={() => {
            clearFilters();
          }}
        >
          Reset
        </Button>
        <Button
          className={`ant-btn ant-btn-primary ant-btn-sm ${classSuffix}`}
          onClick={() => {
            confirm();
          }}
        >
          OK
        </Button>
      </div>
    </div>
  );
}

TableFilterDropdown.propTypes = {
  clearFilters: PropTypes.func,
  confirm: PropTypes.func,
  filters: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    value: PropTypes.string,
  })),
  selectedKeys: PropTypes.arrayOf(PropTypes.string),
  setSelectedKeys: PropTypes.func,
  visible: PropTypes.bool,
};

TableFilterDropdown.defaultProps = {
  clearFilters: () => {},
  confirm: () => {},
  filters: [],
  selectedKeys: [],
  setSelectedKeys: () => {},
  visible: false,
};
